// Shared node-type → colour mapping used by both the welcome canvas
// (spec 30 PR 3) and the project graph view. Picked so the visual
// vocabulary stays consistent — a "person" node looks the same
// during onboarding and on the full graph view.

const NODE_TYPE_COLOR: Record<string, string> = {
	// Entity types (extraction-time + community detection)
	organization: "#a78bfa", // purple
	person: "#7dd3fc", // sky
	company_description: "#f9a8d4", // pink
	industry: "#fbbf24", // amber
	github_org: "#6ee7b7", // emerald
	github_installation: "#6ee7b7", // emerald (sibling of github_org)
	gmail_account: "#fca5a5", // soft red — pairs with email_message
	team_build: "#fb923c", // orange
	pending_member: "#fde68a", // pale amber
	email_message: "#fca5a5", // soft red (spec 33)
	email_thread: "#fca5a5",
	community: "#5eead4", // teal — synthetic clusters
	// Renketsu engine internals — surfaces seldom on visible graphs
	// but worth a neutral colour so nothing renders unstyled.
	chunk: "#a3a3a3", // grey
};

const NODE_TYPE_DEFAULT = "#d4d4d8";

export function colorForNodeType(type: string): string {
	return NODE_TYPE_COLOR[type] ?? NODE_TYPE_DEFAULT;
}
